import { opaccNotifications } from '../../lib/notifications/opacc.lib.notifications.js';
import { generalMessages, accountMessages, paymentMessages, deliveryMessages } from '../messages/opacc.messages.js';

/** @module static */

/**
 * Ausgabe von Meldungen und Darstellung von Modal-Fenster
 *
 */
export class OpaccLog {
	constructor() {
		this.msgType = {
			info: 'info',
			warn: 'warning',
			debug: 'debug',
			error: 'error',
			log: 'success'
		};

		this.mapMessages = Object.assign({}, generalMessages, accountMessages, paymentMessages, deliveryMessages);

		this.moveMessages();
	}

	/**
	 *
	 *
	 * @param {*} type
	 * @returns {*}
	 */
	setColoredOutput(type) {
		if (type === 'success') {
			return ['background: green', 'color: white', 'display: block'].join(';');
		} else if (type === 'error') {
			return ['background: red', 'color: white', 'display: block'].join(';');
		} else if (type === 'warning') {
			return ['background: yellow', 'color: black', 'display: block'].join(';');
		} else if (type === 'debug') {
			return ['background: blue', 'color: white', 'display: block'].join(';');
		}

		return true;
	}

	/**
	 *
	 *
	 * @param {*} [msg=null]
	 * @param {*} type
	 */
	logToConsole(msg = null, type) {
		let consoleColor = null;

		switch (type) {
		case this.msgType.info:
			consoleColor = ['background: green', 'color: white', 'display: block'].join(';');
			// eslint-disable-next-line no-console
			console.info(`%c ${msg}`, consoleColor);
			break;
		case this.msgType.warn:
			consoleColor = ['background: yellow', 'color: black', 'display: block'].join(';');
			// eslint-disable-next-line no-console
			console.warn(`%c ${msg}`, consoleColor);
			break;
		case this.msgType.error:
			consoleColor = ['background: red', 'color: white', 'display: block'].join(';');
			// eslint-disable-next-line no-console
			console.log(`%c ${msg}`, consoleColor, this.getSourceScriptNameFromCallStack());
			break;
		case this.msgType.debug:
			consoleColor = ['background: blue', 'color: white', 'display: block'].join(';');
			// eslint-disable-next-line no-console
			console.debug(`%c ${msg}`, consoleColor, this.getSourceScriptNameFromCallStack());
			break;
		default:
			// eslint-disable-next-line no-console
			console.log(msg);
		}
	}

	/**
	 *
	 *
	 * @param {*} msgObj
	 * @param {*} msgOverride
	 */
	showMessage(msgObj, msgOverride) {
		if(msgObj) {
			let msgCode = msgObj.code;
			let msgText = msgObj.text;
			let msgDisplay = msgOverride ? msgOverride : msgText;
			let msgAddition = msgObj.addition;
			let options = { 'wait': msgObj.wait, 'link': msgObj.link, 'title': msgObj.title };

			if(!msgCode) {
				msgCode = this.mapMessages.messageDefault.code;
			}

			if(msgCode && msgDisplay) {
				let msgType = msgCode.substr(0, 1);
				let msgConsole = `${msgCode}: ${msgText}`;
				if(msgAddition) {
					msgConsole = `${msgConsole} (${msgAddition})`;
				}

				switch (msgType) {
				case '1':
					this.showInfo(msgDisplay, msgConsole, options);
					break;
				case '2':
					this.showWarning(msgDisplay, msgConsole, options);
					break;
				case '3':
					this.showError(msgDisplay, msgConsole, options);
					break;
				case '4':
					this.showDebug(msgDisplay, msgConsole, options);
					break;
				default:
					break;
				}
			}
		}
	}

	/**
	 *
	 *
	 * @param {*} messages
	 * @param {*} response
	 */
	showMessages(messages, response) {
		Array.from(messages).forEach(message => {
			this.showMessage(message, this.mapMessageCodeToText(response, this.mapMessages));
		});
	}

	/**
	 *
	 *
	 * @param {*} frontMessage
	 * @param {*} [consoleMessage=null]
	 * @param {*} [options={}]
	 */
	showInfo(frontMessage, consoleMessage = null, options = {wait: generalMessages.messageDefaultInfo.wait}) {
		if (!consoleMessage) {consoleMessage = frontMessage;}
		opaccNotifications.defaults.notifier.closeButton = true;
		opaccNotifications.success(this.extendMessage(frontMessage, options), options.wait);
		this.logToConsole(consoleMessage, 'info');
	}

	/**
	 *
	 *
	 * @param {*} frontMessage
	 * @param {*} [consoleMessage=null]
	 * @param {*} [options={}]
	 */
	showWarning(frontMessage, consoleMessage = null, options = {wait: generalMessages.messageDefaultWarning.wait}) {
		if (!consoleMessage) {consoleMessage = frontMessage;}
		opaccNotifications.defaults.notifier.closeButton = true;
		opaccNotifications.warning(this.extendMessage(frontMessage, options), options.wait);
		this.logToConsole(consoleMessage, 'warning');
	}

	/**
	 *
	 *
	 * @param {*} frontMessage
	 * @param {*} [consoleMessage=null]
	 * @param {*} [options={}]
	 */
	showError(frontMessage, consoleMessage = null, options = {wait: generalMessages.messageDefaultError.wait}) {
		if (!consoleMessage) {consoleMessage = frontMessage;}
		opaccNotifications.defaults.notifier.closeButton = true;
		opaccNotifications.error(this.extendMessage(frontMessage, options), options.wait);
		this.logToConsole(consoleMessage, 'error');
	}

	/**
	 *
	 *
	 * @param {*} [frontMessage=null]
	 * @param {*} [consoleMessage=null]
	 * @param {*} [options={}]
	 * @returns {*}
	 */
	showDebug(frontMessage = null, consoleMessage = null, options = {wait: generalMessages.messageDefaultDebug.wait}) {
		if (!frontMessage && !consoleMessage) { return; }
		if (frontMessage) {
			if (!consoleMessage) { consoleMessage = frontMessage; }
			opaccNotifications.defaults.notifier.closeButton = true;
			opaccNotifications.message(this.extendMessage(frontMessage, options), options.wait);
		}
        this.logToConsole(consoleMessage, 'debug');
	}

	/**
	 *
	 *
	 * @param {string} content Anzuzeigender HTML-Inhalt im Modal als String
	 * @param {HTMLElement} [headSelector=undefined] HTML Selektor, welcher als Head angezeigt werden soll aus dem übergebenen content
	 * @param {boolean} [startInFullScreen=false] Modal maximiert zu Beginn anzeigen
	 * @param {object} [additionalSettings=undefined] Optionen Objekt für das Modal-Fenster
	 * @param {boolean} [additionalSettings.closable=true] Kann das Modal über den "Schliessen"-Button geschlossen werden? (bei "false" muss das Modal projektseitig geschlossen werden.)
	 * @param {boolean} [additionalSettings.closableByDimmer=true] Klick im Dimmbereich schliesst das Modal?
	 * @param {boolean} [additionalSettings.maximizable=false] Modal maximieren
	 * @param {boolean} [additionalSettings.modal=true] Modal mit Dimmer anzeigen (Interaktion mit Seite wird somit unterbunden)
	 * @param {boolean} [additionalSettings.movable=true] Modal bewegen
	 * @param {boolean} [additionalSettings.moveBounded=false] Verschiebbares Modal aus dem Bildschirm nur innerhalb der Seitenkoordinaten bewegen oder aus dem Bildschirm verschwinden lassen
	 * @param {boolean} [additionalSettings.overflow=true] Modal Inhalt bei unzureichendem Platz mit Scrollbalken darstellen
	 * @param {boolean} [additionalSettings.padding=true] Inhalt vom Modalrand einrücken
	 * @param {boolean} [additionalSettings.resizable=false] Modalgrösse verändern
	 * @param {boolean} [additionalSettings.startMaximized=false] Modal maximiert bei Öffnen darstellen
	 * @param {"slide"|"zoom"|"flipx"|"flipy"|"fade"|"pulse"} [additionalSettings.transition=pulse] - Animationseffekt des Modals
	 * @returns {*}
	 */

	showModal(content, headSelector = undefined, startInFullScreen = undefined, additionalSettings = undefined) {
		let fullScreenOption = false;
		if (startInFullScreen === true) {
			fullScreenOption = true;
		}
		let defaultSettings = {
			'message': content,
			'head': headSelector,
			'maximizable': false,
			'startMaximized': fullScreenOption
		};

		let modalSettings = Object.assign({}, defaultSettings, additionalSettings);

		let isModalOpen = opaccNotifications.modal().isOpen();
		if (!isModalOpen) {
			opaccNotifications.modal().destroy();
		}

		let opaccModal = opaccNotifications.modal()
			.set(modalSettings)
			.show();

		let returnObj = {
			content: opaccModal.elements.content,
			header: opaccModal.elements.header,
			footer: opaccModal.elements.footer
		};

		return returnObj;
	}

	/**
	 *
	 *
	 */
	hideModal() {
		opaccNotifications.modal().destroy();
	}

	/**
	 *
	 *
	 */
	hideConfirm() {
		opaccNotifications.confirm().destroy();
	}

	/**
	 *
	 *
	 * @param {*} content
	 * @param {*} trueLabel
	 * @param {*} falseLabel
	 * @param {*} trueFunction
	 * @param {*} falseFunction
	 * @param {*} [title=undefined]
	 * @param {*} [style=undefined]
	 * @returns {*}
	 */
	showConfirm(content, trueLabel, falseLabel, trueFunction, falseFunction, title = undefined, style = undefined) {
		opaccNotifications.confirm().destroy();
		let opaccConfirm = opaccNotifications.confirm(content, trueFunction, falseFunction).set({ 'labels':{ ok: trueLabel, cancel: falseLabel }, 'title': title, 'style': style });

		let returnObj = {
			content: opaccConfirm.elements.content,
			header: opaccConfirm.elements.header,
			footer: opaccConfirm.elements.footer
		};
		return returnObj;
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	getSourceScriptNameFromCallStack() {
		const error = new Error();

		// Browserkompatibilität (prüfen ob stack unterstützt wird)
		if (error.stack != undefined) {
			const lines = error.stack.split('\n').slice(1);
			const lastStack = [...lines].pop();

			let lineMatch = lastStack.match(/at (?:(.+)\s+\()?(?:(.+?):(\d+)(?::(\d+))?|([^)]+))\)?/);
			if (!lineMatch) { return; }

			let object = null;
			let method = null;
			let functionName = null;
			let typeName = null;
			let methodName = null;
			let isNative = lineMatch[5] === 'native';

			if (lineMatch[1]) {
				functionName = lineMatch[1];
				let methodStart = functionName.lastIndexOf('.');
				if (functionName[methodStart - 1] == '.') methodStart--;
				if (methodStart > 0) {
					object = functionName.substr(0, methodStart);
					method = functionName.substr(methodStart + 1);
					let objectEnd = object.indexOf('.Module');
					if (objectEnd > 0) {
						functionName = functionName.substr(objectEnd + 1);
						object = object.substr(0, objectEnd);
					}
				}
				typeName = null;
			}

			if (method) {
				typeName = object;
				methodName = method;
			}

			if (method === '<anonymous>') {
				methodName = null;
				functionName = null;
			}

			let properties = {
				fileName: lineMatch[2] || null,
				lineNumber: parseInt(lineMatch[3], 10) || null,
				functionName: functionName,
				typeName: typeName,
				methodName: methodName,
				columnNumber: parseInt(lineMatch[4], 10) || null,
				native: isNative
			};
			return properties;
		} else if (error.fileName != undefined) {
			return error.fileName;
		}

		return false;
	}

	/**
	 *
	 *
	 * @param {*} [source=document]
	 * @param {*} [defaultMsg=undefined]
	 */
	moveMessages(source = document, defaultMsg = undefined) {
		let showDefaultMsg = true;
		const portalMessageContainer = source.querySelector('[id^="wp_messages_container_"]');
		if (portalMessageContainer && portalMessageContainer.hasChildNodes()) {
			let infoMessage = portalMessageContainer.querySelectorAll('.Info');
			let errorMessage = portalMessageContainer.querySelectorAll('.Error');
			let warningMessage = portalMessageContainer.querySelectorAll('.Warning');
			let debugMessage = portalMessageContainer.querySelectorAll('.Debug');

			Array.from([...infoMessage, ...errorMessage, ...warningMessage, ...debugMessage], item => {
				let messageType = item.className;
				let messageCode = item.querySelector('.was-message-code');
				let messageAddition = item.querySelector('.was-message-addition');
				let messageWait = item.querySelector('.was-message-wait');
				let frontMessage = item.cloneNode(true);
				let code = '?-?-????';
				let addition = '';
				let options = { wait: '' };
				if(messageCode) {
					frontMessage.querySelector('.was-message-code').remove();
					code = messageCode.innerText;
				}
				if(messageAddition) {
					frontMessage.querySelector('.was-message-addition').remove();
					addition = ` addtion: ${messageAddition.innerText}`;
				}
				if(messageWait) {
					frontMessage.querySelector('.was-message-wait').remove();
					options.wait = messageWait.innerText;
				}
				let consoleMessage = `${code}: ${frontMessage.innerText} (wait: ${options.wait} sec.${addition})`;

				switch (messageType) {
				case 'Error':
					this.showError(frontMessage.innerText, consoleMessage, options);
					showDefaultMsg = false;
					break;
				case 'Info':
					this.showInfo(frontMessage.innerText, consoleMessage, options);
					showDefaultMsg = false;
					break;
				case 'Warning':
					this.showWarning(frontMessage.innerText, consoleMessage, options);
					showDefaultMsg = false;
					break;
				case 'Debug':
					this.showDebug(frontMessage.innerText, consoleMessage, options);
					showDefaultMsg = false;
					break;
				default:
					break;
				}
			});
			portalMessageContainer.remove();
		}
		if (typeof defaultMsg === 'string' && showDefaultMsg) {
			this.showMessage(this.mapMessages.messageDefault, defaultMsg);
		} else if (typeof defaultMsg === 'object' && showDefaultMsg) {
			let consoleOutput = defaultMsg.consoleOnlyOutput;
			if (consoleOutput && consoleOutput.length > 0) {
				this.showDebug('', consoleOutput);
			}
		}
	}

	/**
	 *
	 *
	 * @param {*} response
	 * @param {*} mappedMessages
	 * @returns {*}
	 */
	mapMessageCodeToText(response, mappedMessages) {
		let textMessage = null;
		if (response.pluginId) {
			if (response.pluginId === 'paymentType') {
				switch (+response.paymentType) {
				case 1:
					textMessage = mappedMessages.messagePaymentTypeCreditCard.text;
					break;
				case 2:
					textMessage = mappedMessages.messagePaymentTypeInvoice.text;
					break;
				case 5:
					textMessage = mappedMessages.messagePaymentTypeInAdvance.text;
					break;
				case 6:
					textMessage = mappedMessages.messagePaymentTypeOnDelivery.text;
					break;
				default:
					textMessage = mappedMessages.messagePaymentTypeGeneral.text;
					break;
				}
			} else if (response.pluginId === 'deliveryType') {
				textMessage = mappedMessages.messageDeliveryTypeGeneral.text;
			} else if (response.pluginId === 'checkoutAdressChange') {
				textMessage = mappedMessages.messageChangeSuccess.text;
			} else if (response.pluginId.length > 0) {
				textMessage = { consoleOnlyOutput: mappedMessages.messageEmptyText.text };
			}
		}
		return textMessage;
	}

	/**
	 *
	 *
	 * @param {*} message
	 * @param {*} option
	 * @returns {*}
	 */
	extendMessage(message, option) {
		if(option.link)
		{
			message = `<a class="notifications-link" href="${option.link}" title="${option.title}">${message}</a>`;
		}
		return message;
	}
}